import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-muted/30 mt-auto" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt="Venda de Garagem" className="h-14 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              O marketplace onde você compra e vende de tudo. Produtos físicos, digitais e serviços.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3" style={{ fontFamily: 'Outfit' }}>Marketplace</h4>
            <ul className="space-y-2">
              <li><Link to="/products" className="text-sm text-muted-foreground hover:text-primary transition-colors">Explorar</Link></li>
              <li><Link to="/products?category=Eletrônicos" className="text-sm text-muted-foreground hover:text-primary transition-colors">Eletrônicos</Link></li>
              <li><Link to="/products?category=Moda" className="text-sm text-muted-foreground hover:text-primary transition-colors">Moda</Link></li>
              <li><Link to="/products?category=Veículos" className="text-sm text-muted-foreground hover:text-primary transition-colors">Veículos</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3" style={{ fontFamily: 'Outfit' }}>Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/termos" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-terms-link">Termos de Uso</Link></li>
              <li><Link to="/privacidade" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-privacy-link">Política de Privacidade</Link></li>
              <li><span className="text-sm text-muted-foreground">Central de Ajuda</span></li>
              <li><span className="text-sm text-muted-foreground">Segurança</span></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3" style={{ fontFamily: 'Outfit' }}>Parceiros</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-muted-foreground">OASIS Exchange</span></li>
              <li><span className="text-sm text-muted-foreground">Wise Eagle</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">&copy; 2026 Venda de Garagem. Todos os direitos reservados.</p>
          <div className="flex items-center gap-4">
            <Link to="/termos" className="text-xs text-muted-foreground hover:text-primary transition-colors">Termos</Link>
            <Link to="/privacidade" className="text-xs text-muted-foreground hover:text-primary transition-colors">Privacidade</Link>
            <span className="text-xs text-muted-foreground flex items-center gap-1">
              Pagamentos via <span className="font-semibold text-primary ml-1">OASIS</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
